import axios from "axios";
import Config from "src/config";

const v2_actionCriarAutomacao = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${clienteId}/automacoes/criar`,
        data
    });
};

export default v2_actionCriarAutomacao;
